<!-- Header -->
<nz-row
  class="coupon-header"
  align="middle"
  justify="space-between"
  style="border-bottom: 1px solid #f0f0f0; padding: 12px 0; background: #fff"
>
  <!-- Back -->
  <nz-col [nzXs]="4" [nzSm]="2" [nzMd]="1">
    <button nz-button nzType="text" (click)="goBack()">
      <i nz-icon nzType="arrow-left"></i>
    </button>
  </nz-col>

  <!-- Title -->
  <nz-col [nzXs]="16" [nzSm]="14" [nzMd]="14" class="text-center">
    <h1 class="title m-0">
      <b>{{ couponName }}</b>
    </h1>
  </nz-col>

  <!-- Use Count -->
  <nz-col
    [nzXs]="24"
    [nzSm]="8"
    [nzMd]="4"
    class="text-md-right text-center mt-2 mt-md-0"
  >
    <div>
      <strong>Total Coupon Use: </strong>
      <nz-tag [nzColor]="useCount === 0 ? 'red' : 'green'" class="ml-1">
        {{ useCount }}
      </nz-tag>
    </div>
  </nz-col>

  <!-- Total Amount -->
  <nz-col
    [nzXs]="24"
    [nzSm]="10"
    [nzMd]="4"
    class="text-md-right text-center mt-2 mt-md-0"
  >
    <div>
      <strong>Total Sold Amount: </strong>
      <nz-tag nzColor="blue" class="ml-1">₹{{ couponTotalAmount }}</nz-tag>
    </div>
  </nz-col>
</nz-row>

<nz-card>
  <!-- Date & Download -->
  <nz-row nzJustify="end" [nzGutter]="16" class="mb-4">
    <!-- Date Range -->
    <nz-col [nzXs]="24" [nzSm]="14" [nzMd]="8">
      <nz-form-item>
        <nz-form-control [nzSpan]="24" nzErrorTip="Please select a Date!">
          <nz-range-picker
            class="width-100"
            [(ngModel)]="dateRange"
            (ngModelChange)="onChangeDateRange($event)"
          ></nz-range-picker>
        </nz-form-control>
      </nz-form-item>
    </nz-col>

    <!-- Download -->
    <nz-col [nzXs]="24" [nzSm]="8" [nzMd]="4">
      <button
        nz-button
        nzType="primary"
        (click)="downloadCouponExcel()"
        class="w-full"
      >
        <i nz-icon nzType="download"></i> Download Excel
      </button>
    </nz-col>
  </nz-row>

  <!-- Table -->
  <nz-table
    [nzData]="couponData"
    [nzLoading]="loading"
    [nzTotal]="totalCount"
    [(nzPageSize)]="pageSize"
    [(nzPageIndex)]="pageIndex"
    [nzFrontPagination]="false"
    nzShowSizeChanger
    (nzQueryParams)="onQueryParamsChange($event)"
    [nzScroll]="{ x: '900px' }"
  >
    <thead>
      <tr>
        <th>User</th>
        <th>Phone</th>
        <th>Plan</th>
        <th>Test Series</th>
        <th>Paid Amount</th>
        <th>Date</th>
        <th>Type</th>
        <th>Payment Status</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of couponData">
        <td>
          <nz-avatar
            *ngIf="item.user?.avatar"
            [nzSrc]="item.user.avatar"
            class="mr-2"
          ></nz-avatar>
          {{ item.user?.name || "N/A" }}
        </td>
        <td>{{ item.customerDetails }}</td>
        <td>{{ item.planName || "N/A" }}</td>
        <td>
          <span *ngIf="item.testSeries.length === 0">N/A</span>
          <ul class="pl-3 mb-0">
            <li *ngFor="let ts of item.testSeries">{{ ts.name }}</li>
          </ul>
        </td>
        <td>
          <nz-tag nzColor="red">₹{{ item.amount }}</nz-tag>
          <span>-</span>
          <nz-tag nzColor="green">₹{{ item.discountValue }}</nz-tag>
          <span>=</span>
          <nz-tag nzColor="green">₹{{ item.totalAmount }}</nz-tag>
        </td>
        <td>{{ item.startDate | date : "mediumDate" }}</td>
        <td>
          <nz-tag
            [nzColor]="item.discountType === 'PERCENTAGE' ? 'blue' : 'orange'"
          >
            {{ item.discountType === "PERCENTAGE" ? "Percentage" : "Flat" }}
          </nz-tag>
        </td>
        <td>
          <nz-tag [nzColor]="item.phonepeLog?.success ? 'green' : 'red'">
            {{ item.phonepeLog?.data?.state }}
          </nz-tag>
        </td>
      </tr>
    </tbody>
  </nz-table>
</nz-card>
